<script>
import Layout from '@layouts/main'
import CouponForm from './CouponForm'

export default {
  page: {
    title: '新增優惠券',
    meta: [{ name: 'description', content: 'Add Coupon' }],
  },
  components: { Layout, CouponForm },

  methods: {
    backToList() {
      this.$router.push({ name: 'coupon' })
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageHeader title="新增優惠券" />
    <el-card>
      <CouponForm @back="backToList" />
    </el-card>
  </Layout>
</template>

